/* eslint-disable react/jsx-no-undef,react/jsx-props-no-spreading,react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Space, DatePicker, Select, Button, Table, Row, Col, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import { formatDate, getAccountFullName } from "../../lib/utils";
import { updateServiceStatus, clearServices } from "../../store/slices/services";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { displayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import AuthService from "../../services/AuthService";
import ModalWindow from "../ModalWindow/ModalWindow";
import { hasAccess } from "../RolesModule/hasAccess";
import { exportToXLS } from "../../store/slices/xlsExport";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";
import BulkProductsTableModal from "./BulkProductsTableModal/BulkProductsTableModal";
import { ReactComponent as TreeButton } from "../../img/treeButton.svg";
import { BlockingObjTypes } from "../../lib/const/blockingObjTypes";
import { getBlockingStatusIcon } from "../../lib/utils/getBlockingStatusIcon";
import BlockingModal from "../BlockingModal/BlockingModal";
import useBlockingMode from "../../lib/hooks/useBlockingMode";
import { BulkServicesSearchFilters } from "./BulkServicesSearchFilters/BulkServicesSearchFilters";
import { useLoading } from "../../lib/hooks/useLoading";
import "../../styles/filters-form.less";
import "./BulkServices.less";

const dateFormat = displayFormat;

const style = {
  modalHeader: {
    fontSize: "14px",
    color: "#5D6C7A",
    textAlign: "center",
  },
  modalSubHeader: {
    fontSize: "16px",
    color: "#112244",
    textAlign: "center",
  },
  modalInitiator: {
    fontSize: "14px",
    color: "#5D6C7A",
    textAlign: "center",
    label: {
      color: "#000000",
      marginLeft: "5px",
    },
  },
  modalFooter: {
    fontSize: "16px",
    color: "#112244",
    textAlign: "center",
    marginTop: "15px",
    marginBottom: "0",
  },
};

const BulkServices = ({
  defaultServicesSearchParams,
  handleSearchServices,
  resetSearchServices,
  isLoaded,
  filteredServiceStatuses,
  form,
}) => {
  const userName = jwtDecode(AuthService.getCurrentUser());
  const dispatch = useDispatch();
  const dateNow = moment().startOf("day");
  const [date, setDate] = useState(toHttpFormatStartOfDay(dateNow));
  const [calendarValue, setCalendarValue] = useState(dateNow);
  const [filtersCollapseState, setFiltersCollapsState] = useState("unfolded");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [activeModal, setActiveModal] = useState(false);
  const [formValues, setFormValues] = useState("");
  const { products, serviceStatus, serviceStatusLoading } = useSelector(
    (state) => state.rtkDictionaries
  );
  const services = useSelector((state) => state.service);
  const servicesSearchingLoading = useSelector((state) => state.service.servicesSearchingLoading);
  const serviceTypes = useSelector((state) => state.service.serviceTypes);
  const [activeModalProduct, setActiveModalProduct] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({ productId: null, agreementId: null });

  const [serviceStatusAlias, setServiceStatusAlias] = useState(undefined);
  const [searchServicesState, setSearchServicesState] = useState("");
  const [startDayDisableInChangeStatus, setStartDayDisableInChangeStatus] = useState("");
  const [endDayDisableInChangeStatus, setEndDisableDayInChangeStatus] = useState("");

  const isBlockingMode = useBlockingMode();

  const [objectBlockingId, setObjectBlockingId] = useState("");

  const handleShowBlockingModal = (objId) => {
    setObjectBlockingId(objId);
  };

  const handleHideBlockingModal = () => {
    setObjectBlockingId("");
  };

  const accountName = objectBlockingId?.agreement?.account?.individual
    ? [
        objectBlockingId?.agreement?.account?.individual?.lastName,
        objectBlockingId?.agreement?.account?.individual?.firstName,
        objectBlockingId?.agreement?.account?.individual?.middleName,
      ]
        .filter(Boolean)
        .join(" ")
    : objectBlockingId?.agreement?.account?.organization?.fullName;

  const resetSearchPaymentsAndResetSetSelectedRowKeys = () => {
    resetSearchServices();
    setSelectedRowKeys([]);
    setSearchServicesState("");
  };

  const getTableHeight = () => (filtersCollapseState === "unfolded" ? `${51}vh` : `${64}vh`);

  useEffect(() => {
    if (checkIsLoaded(servicesSearchingLoading)) {
      setSearchServicesState(services.service);
    }
  }, [services.service]);

  const getColumnsProducts = () => [
    {
      title: "ID продукта",
      dataIndex: "id",
      key: "id",
      hidden: true,
    },
    {
      title: "Клиент",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "ID договора",
      dataIndex: "agreementId",
      key: "agreementId",
      hidden: true,
    },
    {
      title: "Номер договора",
      dataIndex: "agreementNumber",
      key: "agreementNumber",
    },
    {
      title: "Группа продуктов",
      dataIndex: "productGroup",
      key: "productGroup",
    },
    {
      title: "Тип продукта",
      dataIndex: "productType",
      key: "productType",
    },
    {
      title: "",
      dataIndex: "blockingStatus",
      key: "blockingStatus",
      width: "50px",
      render: (blockingStatus, record) => (
        <div>
          {getBlockingStatusIcon(blockingStatus, () => handleShowBlockingModal(record))}
          {/* {console.log("blockingStatus", blockingStatus)} */}
        </div>
      ),
    },
    {
      title: "ID предложения",
      dataIndex: "offeringId",
      key: "offeringId",
      ellipsis: true,
      hidden: true,
    },
    {
      title: "Код предложения",
      dataIndex: "offeringName",
      key: "offeringName",
      ellipsis: true,
      hidden: true,
    },
    {
      title: "Наименование предложения",
      dataIndex: "offeringExtName",
      key: "offeringExtName",
      ellipsis: true,
    },
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      render: (value) => <span className="bulk-services__period">{value}</span>,
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
    },
    {
      dataIndex: "",
      key: "x",
      render: (record) => (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            icon={<TreeButton opacity={record.bounded ? 1 : 0.5} />}
            onClick={(e) => {
              e.stopPropagation();
              setActiveModalProduct(true);
              setSelectedProduct({ productId: record?.id, agreementId: record?.agreementId });
            }}
            className="button-icon"
            style={{ outline: "none" }}
            disabled={!record.bounded}
          />
        </div>
      ),
      width: 100,
    },
  ];

  const [columns, setColumns] = useState(getColumnsProducts());

  useEffect(() => {
    setColumns(getColumnsProducts());
  }, [isBlockingMode]);

  // Очистка списка продуктов по выходу
  useEffect(
    () => () => {
      dispatch(clearServices());
    },
    []
  );

  const checkForCurrentDate = () => {
    let currentDate = false;
    if (moment(startDayDisableInChangeStatus || "").isAfter(dateNow)) {
      currentDate = true;
    }
    return currentDate;
  };

  useEffect(() => {
    if (activeModal === false) setServiceStatusAlias(undefined);

    // поле "Дата": должно быть пустое, если задан фильтр "Дата"
    const onDateForm = form.getFieldValue("onDate");
    if (onDateForm) {
      setCalendarValue("");
      setDate("");
      return;
    }

    setCalendarValue(!checkForCurrentDate() ? dateNow : "");
    setDate(!checkForCurrentDate() ? toHttpFormatStartOfDay(dateNow) : "");
  }, [activeModal]);

  const { isLoading, startLoading, stopLoading } = useLoading();

  const renderBtnXLS = () => {
    const handleExport = () => {
      startLoading();
      const selected =
        isLoaded &&
        searchServicesState &&
        searchServicesState?.filter((item) => selectedRowKeys.includes(item.id));
      const { display_name: author } = jwtDecode(AuthService.getCurrentUser());
      const exportedData = {
        fileName: `Продукты_${formatDate.toDisplayFormat(moment())}`,
        title: "Выгрузка данных в формате xls",
        description: "Выгрузка данных",
        author,
        header: [
          { name: "id", title: "ID продукта", type: "String" },
          { name: "fullName", title: "Клиент", type: "String" },
          { name: "agreementId", title: "ID договора", type: "String" },
          { name: "agreementNumber", title: "Номер договора", type: "String" },
          { name: "serviceType", title: "Тип продукта", type: "String" },
          { name: "offeringName", title: "Код предложения", type: "String" },
          { name: "extName", title: "Наименование предложения", type: "String" },
          { name: "period", title: "Период", type: "String" },
          { name: "status", title: "Статус", type: "String" },
        ],
        data: selected.map((item) => {
          const serviceStatusFind =
            checkIsLoaded(serviceStatusLoading) &&
            serviceStatus.find(({ id: ssId }) => ssId === item?.serviceStatusId);
          const period = [
            item.fromDate ? formatDate.toDisplayFormat(item.fromDate) : "",
            item.toDate ? formatDate.toDisplayFormat(item.toDate) : "",
          ].join(" - ");

          return {
            id: item?.id,
            fullName: item?.agreement?.account ? getAccountFullName(item?.agreement?.account) : "",
            agreementId: item?.agreement?.id,
            agreementNumber: item?.agreement?.agreementNumber,
            serviceType: item?.serviceType?.name,
            offeringName: item?.offering?.name,
            extName: item?.offering?.extName,
            period,
            status: serviceStatusFind?.name,
          };
        }),
      };

      dispatch(exportToXLS(exportedData)).finally(startLoading);
    };

    return (
      <Button
        type="primary"
        disabled={selectedRowKeys.length === 0}
        loading={isLoading}
        onClick={handleExport}
      >
        Выгрузить в XLS
      </Button>
    );
  };

  const tableData =
    isLoaded &&
    searchServicesState &&
    searchServicesState
      .map(
        ({
          agreement,
          serviceType,
          tariff,
          fromDate,
          toDate,
          serviceStatusId,
          documents = "0-0",
          id,
          offering,
          bounded,
          blockingStatus,
          agreementId,
        }) => {
          const serviceStatusFind =
            checkIsLoaded(serviceStatusLoading) &&
            serviceStatus.find(({ id: ssId }) => ssId === serviceStatusId);

          return {
            key: id,
            id,
            fullName: agreement?.account ? getAccountFullName(agreement?.account) : "",
            accountId: agreement?.account?.id,
            agreementNumber: agreement?.agreementNumber,
            agreementId,
            serviceType: serviceType.name,
            tariffName: tariff?.name,
            period: [
              fromDate ? formatDate.toDisplayFormat(fromDate) : "",
              toDate ? formatDate.toDisplayFormat(toDate) : "",
            ].join("\n"),
            status: serviceStatusFind.name,
            documents,
            productId: serviceType?.productId,
            productType: serviceTypes.find(({ id }) => id === serviceType?.id)?.name,
            productGroup: products.find(({ id }) => {
              return id === serviceType?.productId;
            })?.name,
            offeringId: offering?.id,
            offeringName: offering?.name,
            offeringExtName: offering?.extName,
            bounded,
            blockingStatus,
            agreement,
            toDate,
          };
        }
      )
      .sort((a, b) => (a.fullName > b.fullName ? 1 : -1));

  const onShowModalForStatus = () => {
    setActiveModal(true);
    const selectedServices =
      searchServicesState &&
      searchServicesState.filter((item) => selectedRowKeys.includes(item.id));
    const datesFrom = selectedServices.map((item) => moment(item.fromDate));
    const datesTo = selectedServices.map((item) => moment(item.toDate));

    setStartDayDisableInChangeStatus(moment.max(datesFrom).add(1, "day"));
    setEndDisableDayInChangeStatus(moment.min(datesTo));
  };

  const disabledDatesForChangingStatus = (cur) =>
    cur.isBefore(startDayDisableInChangeStatus) || cur.isAfter(endDayDisableInChangeStatus);

  const onChangeDate = (value) => {
    setDate(toHttpFormatStartOfDay(value));
    setCalendarValue(value);
  };

  const onChangeStatus = (value) => {
    setServiceStatusAlias(value);
  };

  const onFinishChangeStatus = async () => {
    startLoading();
    const serviceStatusData = {
      serviceId: selectedRowKeys,
      status: serviceStatusAlias,
    };
    await dispatch(updateServiceStatus({ date, serviceStatusData })).finally(stopLoading);

    setActiveModal(false);
    // Обсуждали с Таней Виноградовой и Женей Ковтуненко, эта задержка нужна, чтобы в базе успело пройти обновление
    await setTimeout(() => {
      handleSearchServices(formValues);
    }, 2e3);
  };

  const changeStatusBtnTooltip = (function fn() {
    if (selectedRowKeys.length === 0) {
      return "Выберите продукт";
    }
    return "";
  })();

  const onSearch = (values) => {
    setSelectedRowKeys([]);
    handleSearchServices(values);
    setFormValues(values);
  };

  return (
    <>
      <div className="inner-row" style={{ height: "50px" }}>
        <Row justify="space-between" align="middle">
          <Col>
            <h1>Массовые операции по работе с продуктами</h1>
          </Col>
        </Row>
      </div>
      <BulkServicesSearchFilters
        filteredServiceStatuses={filteredServiceStatuses}
        resetSearchPaymentsAndResetSetSelectedRowKeys={
          resetSearchPaymentsAndResetSetSelectedRowKeys
        }
        filtersCollapseState={filtersCollapseState}
        form={form}
        defaultServicesSearchParams={defaultServicesSearchParams}
        onSearch={onSearch}
        setFiltersCollapsState={setFiltersCollapsState}
      />
      <Row justify="end">
        <ToggleColumns tableName="services-table" columns={columns} setColumns={setColumns} />
      </Row>
      <Table
        columns={columns.filter(({ hidden }) => !hidden)}
        dataSource={tableData}
        size="small"
        pagination={false}
        loading={checkIsLoading(servicesSearchingLoading)}
        scroll={{ y: getTableHeight() }}
        className="bulk-products__table"
        rowSelection={{
          selectedRowKeys,
          onChange: (selectedKeys) => {
            setSelectedRowKeys(selectedKeys);
          },
        }}
      />
      <Row justify="center" className="payments__pagination">
        <Space className="buttons-container">
          {renderBtnXLS()}
          {hasAccess("MENU.SERVICES.WRITE") && (
            <Tooltip title={changeStatusBtnTooltip}>
              <Button
                type="primary"
                onClick={() => onShowModalForStatus()}
                disabled={selectedRowKeys.length === 0}
              >
                Изменить статус
              </Button>
            </Tooltip>
          )}
        </Space>
      </Row>
      <ModalWindow
        visible={activeModal}
        handleCancel={() => setActiveModal(false)}
        handleReset={() => setActiveModal(false)}
        handleSubmit={onFinishChangeStatus}
        cancelTextButton="Отмена"
        submitTextButton="Далее"
        disabled={!serviceStatusAlias || !date}
        submitButtonLoading={isLoading}
      >
        <p style={style.modalHeader}>Будет сформировано задание на выполнение операции</p>
        <p style={style.modalSubHeader}>Изменение статуса продуктов</p>
        <p style={style.modalInitiator}>
          Инициатор:
          <span style={style.modalInitiator.label}>{userName.display_name}</span>
        </p>
        <Row justify="center" align="top" style={{ width: "100%" }}>
          <Col span={7} style={{ paddingRight: "10px" }}>
            <DatePicker
              allowClear={false}
              onChange={onChangeDate}
              defaultValue={dateNow}
              value={calendarValue}
              style={{ width: "100%" }}
              disabledDate={disabledDatesForChangingStatus}
              format={dateFormat}
            />
          </Col>
          <Col span={10} style={{ paddingLeft: "10px" }}>
            <Select
              style={{ width: "100%" }}
              value={serviceStatusAlias}
              onChange={onChangeStatus}
              placeholder="Выберите статус"
            >
              {filteredServiceStatuses?.map((item) => (
                <Select.Option key={item.id} value={item.alias}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>

        <p style={style.modalFooter}>Для продолжения нажмите «Далее»</p>
      </ModalWindow>

      <ModalWindow
        visible={activeModalProduct}
        handleCancel={() => setActiveModalProduct(false)}
        handleReset={() => setActiveModalProduct(false)}
        footerHide
        width="900px"
      >
        <BulkProductsTableModal selectedProduct={selectedProduct} />
      </ModalWindow>

      <BlockingModal
        objectTypeId={BlockingObjTypes.Продукт}
        objectId={objectBlockingId?.id}
        handleHideModal={handleHideBlockingModal}
        visibleModal={!!objectBlockingId?.id}
        accountName={accountName}
        serviceAgreementId={objectBlockingId?.agreementId}
        agreementNumber={objectBlockingId?.agreementNumber}
        serviceAgreementAccountId={objectBlockingId?.accountId}
        serviceName={objectBlockingId?.serviceType}
        dateObjectToForCalendar={objectBlockingId?.toDate}
      />
    </>
  );
};

export default BulkServices;
